"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewSerialDeviceResponseT = exports.NewSerialDeviceResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const serial_device_js_1 = require("../../solarxr-protocol/rpc/serial-device.js");
class NewSerialDeviceResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsNewSerialDeviceResponse(bb, obj) {
        return (obj || new NewSerialDeviceResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsNewSerialDeviceResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new NewSerialDeviceResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    device(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new serial_device_js_1.SerialDevice()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startNewSerialDeviceResponse(builder) {
        builder.startObject(1);
    }
    static addDevice(builder, deviceOffset) {
        builder.addFieldOffset(0, deviceOffset, 0);
    }
    static endNewSerialDeviceResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createNewSerialDeviceResponse(builder, deviceOffset) {
        NewSerialDeviceResponse.startNewSerialDeviceResponse(builder);
        NewSerialDeviceResponse.addDevice(builder, deviceOffset);
        return NewSerialDeviceResponse.endNewSerialDeviceResponse(builder);
    }
    unpack() {
        return new NewSerialDeviceResponseT((this.device() !== null ? this.device().unpack() : null));
    }
    unpackTo(_o) {
        _o.device = (this.device() !== null ? this.device().unpack() : null);
    }
}
exports.NewSerialDeviceResponse = NewSerialDeviceResponse;
class NewSerialDeviceResponseT {
    constructor(device = null) {
        this.device = device;
    }
    pack(builder) {
        const device = (this.device !== null ? this.device.pack(builder) : 0);
        return NewSerialDeviceResponse.createNewSerialDeviceResponse(builder, device);
    }
}
exports.NewSerialDeviceResponseT = NewSerialDeviceResponseT;
